import { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "components/atoms";
import { ProgressBar } from "components/molecules";
import { InputControl } from "components/organism";
import { useOnBoardingGs1 } from "partner/_hooks";
import userDataSchema from "partner/Gs1/formSchemas/userData.schema";

const prefix = "vv-account-user-data";

const UserData = () => {
  const { state } = useLocation();
  const navigate = useNavigate()
  const { partner } = useParams();
  const initialized = useRef();

  const { logoutAuth0, lookAndFeel, resetEnrollmentStep, sendUserData } = useOnBoardingGs1();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(userDataSchema)
  });

  const { isLoading } = useSelector((s) => s.partner?.[partner]?.enrollmentStepGs1);

  const onSubmit = (data) => sendUserData(state?._id, data)
    .then((d) => {
      if (d?.data) {
        navigate(`/partner/${partner}/companyData`, { state });
      }
    }
  );

  const checkIt = useCallback(() => {
    if (!initialized?.current) {
      initialized.current = true;
      if (!state?.token || !state?._id || !state?.email) {
        logoutAuth0(partner);
        navigate(`/partner/${partner}/auth0`);
      }
    }
  }, [logoutAuth0, navigate, partner, state]);

  useEffect(() => {
    return () => {
      resetEnrollmentStep();
    }
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    checkIt();
  }, [checkIt]);

  return (
    <div className={prefix}>
      <div className="mb-5">
        <ProgressBar 
          progress={2} max={5} 
          color={lookAndFeel?.progressbar}
        />
      </div>
      <div className="flex flex-wrap flex-col gap-5">
        <p className="text-center text-3xl font-bold mx-auto">Nombre y apellido</p>
        <p className="text-center text-1xl mx-auto pb-5">Para conocerte mejor</p>

        <form 
          className="flex flex-wrap flex-col gap-7"
          onSubmit={handleSubmit(onSubmit)}
        >
          <InputControl
            errors={errors?.firstName}
            label="Nombre"
            orientation="vertical"
            inputProps={{
              autoComplete: "off",
              placeholder: "Ej. Marisol",
              ...register("firstName")}
            }
          />

          <InputControl
            errors={errors?.lastName}
            label="Apellido"
            orientation="vertical"
            inputProps={{
              autoComplete: "off",
              placeholder: "Ej. Rodríguez",
              ...register("lastName")}
            }
          />

          <Button
            className="text-white rounded-lg"
            disabled={isLoading}
            style={{
              backgroundColor: lookAndFeel?.primary?.solid,
              color: lookAndFeel?.primary?.text
            }}
            fullwidth
            pulse
            spin={isLoading}
            type="submit"
          >Continuar</Button>
        </form>
      </div>
    </div>
  )
};

export default UserData;
